import { render, staticRenderFns } from "./TabsHorizontal.vue?vue&type=template&id=1c227186&"
import script from "./TabsHorizontal.vue?vue&type=script&lang=js&"
export * from "./TabsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports